import React, { useState } from 'react'
import StatsComponent2 from '../../../BuisnessDashboard/common/StatsComponent2'

export default function Events() {
    const [tableData, settableData] = useState([])
    const [statsData, setstatsData] = useState([
        { value: "100%", name: "entered Basic stage", color: "#6EBA80", dropOff: "10%" },
        { value: "22%", name: "rejected at 1st Level Rejection", color: "#6EBA80E5", dropOff: "10%" },
        { value: "61%", name: "moved to KYC Verification", color: "#6EBA80CC", dropOff: "10%" },
        { value: "48%", name: "Completed Eligibility Form", color: "#6EBA80B2", dropOff: "10%" },
        { value: "36%", name: "received Loan Offer", color: "#6EBA8099", dropOff: "10%" },
        { value: "29%", name: "provided More Info", color: "#6EBA8080", dropOff: "10%" },
        { value: "24%", name: "Submitted Bank Details", color: "#6EBA8066", dropOff: "10%" },
        { value: "20%", name: "uploaded Documents", color: "#6EBA804D", dropOff: "10%" },
        { value: "16%", name: "completed Loan Application", color: "#6EBA8033", dropOff: "10%" },
        { value: "10%", name: "Reached Complete", color: "#F0B96C", dropOff: "10%" },
    ])
    return (
        <>
            <div className="OverView-Main-Section">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className="custom-tabss-new text-center" style={{ margin: '25px', width: '20%' }}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M32.5 26.6668V20.01C32.5 17.5327 32.5 16.2939 32.074 15.1602C31.648 14.0265 30.8323 13.0943 29.201 11.2299L26.6667 8.3335H13.3333L10.799 11.2299C9.16763 13.0943 8.35197 14.0265 7.92598 15.1602C7.5 16.2939 7.5 17.5327 7.5 20.01V26.6668C7.5 31.3808 7.5 33.7378 8.96447 35.2023C10.4289 36.6668 12.7859 36.6668 17.5 36.6668H22.5C27.214 36.6668 29.571 36.6668 31.0355 35.2023C32.5 33.7378 32.5 31.3808 32.5 26.6668Z" stroke="#0E2B94" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15.834 26.1387C15.834 28.1877 18.9238 29.8675 21.8882 28.9257C24.8527 27.9837 24.4168 25.2082 23.4112 24.1182C22.4055 23.0283 20.9257 23.211 19.2338 23.1253C15.4319 22.9325 15.1635 19.2872 18.2418 17.845C20.5002 16.7868 23.3972 18.1438 23.7308 20.0002M19.9523 15.8335V17.463M19.9523 29.5342V30.8335" stroke="#0E2B94" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12.5 3.3335H27.5C28.2765 3.3335 28.6648 3.3335 28.9712 3.46036C29.3795 3.62951 29.704 3.95398 29.8732 4.36236C30 4.66865 30 5.05693 30 5.8335C30 6.61006 30 6.99835 29.8732 7.30463C29.704 7.71301 29.3795 8.03748 28.9712 8.20663C28.6648 8.3335 28.2765 8.3335 27.5 8.3335H12.5C11.7234 8.3335 11.3352 8.3335 11.0289 8.20663C10.6205 8.03748 10.296 7.71301 10.1269 7.30463C10 6.99835 10 6.61006 10 5.8335C10 5.05693 10 4.66865 10.1269 4.36236C10.296 3.95398 10.6205 3.62951 11.0289 3.46036C11.3352 3.3335 11.7234 3.3335 12.5 3.3335Z" stroke="#0E2B94" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <h5>400</h5>
                        <h6>Total Events Fired</h6>
                    </div>
                    <div className="custom-tabss-new text-center" style={{ margin: '25px', width: '20%' }}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M25.0007 13.3333C25.0007 8.73097 21.2697 5 16.6673 5C12.065 5 8.33398 8.73097 8.33398 13.3333C8.33398 17.9357 12.065 21.6667 16.6673 21.6667C21.2697 21.6667 25.0007 17.9357 25.0007 13.3333Z" stroke="#4FA7C7" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M5 33.3332C5 26.8898 10.2234 21.6665 16.6667 21.6665C19.9312 21.6665 22.8825 23.0073 25 25.1682" stroke="#4FA7C7" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M21.666 30.8333C21.666 30.8333 23.9135 31.6778 24.9993 35C24.9993 35 30.2935 26.6667 34.9993 25" stroke="#4FA7C7" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        <h5>400</h5>
                        <h6>Unique Users</h6>
                    </div>
                    <div className="custom-tabss-new text-center" style={{ margin: '25px', width: '20%' }}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M23.7703 5.99911C21.9933 4.22203 21.1048 3.3335 20.0007 3.3335C18.8965 3.3335 18.008 4.22203 16.2309 5.99911C15.1645 7.0655 14.1078 7.5606 12.5875 7.5606C11.26 7.5606 9.37137 7.30313 8.33398 8.34923C7.3048 9.38706 7.56112 11.2679 7.56112 12.5869C7.56112 14.1073 7.06598 15.164 5.99957 16.2304C4.22252 18.0075 3.334 18.896 3.33398 20.0002C3.33402 21.1042 4.22255 21.9928 5.99962 23.7698C7.19425 24.9645 7.56112 25.7358 7.56112 27.4133C7.56112 28.7408 7.30367 30.6295 8.3498 31.6668C9.38762 32.696 11.2685 32.4397 12.5874 32.4397C14.2065 32.4397 14.9861 32.7563 16.1416 33.9118C17.1255 34.8958 18.4445 36.6668 20.0007 36.6668C21.5568 36.6668 22.8758 34.8958 23.8597 33.9118C25.0152 32.7563 25.7948 32.4397 27.4138 32.4397C28.7328 32.4397 30.6136 32.696 31.6515 31.6668M31.6515 31.6668C32.6976 30.6295 32.4401 28.7408 32.4401 27.4133C32.4401 25.7358 32.807 24.9645 34.0017 23.7698C35.7788 21.9928 36.6673 21.1042 36.6673 20.0002C36.6673 18.896 35.7788 18.0075 34.0017 16.2304M31.6515 31.6668H31.6673" stroke="#90A66E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.334 17.1797C13.334 17.1797 17.084 16.6668 20.0007 23.3335C20.0007 23.3335 28.432 6.66683 36.6673 3.3335" stroke="#90A66E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>


                        <h5>400</h5>
                        <h6>Valid Events</h6>
                    </div>
                    <div className="custom-tabss-new text-center" style={{ margin: '25px', width: '20%' }}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.75 8.3335L32.0833 31.6668" stroke="#FC8A8C" stroke-width="2.5625" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M37.0833 20.0002C37.0833 10.7954 29.6213 3.3335 20.4167 3.3335C11.2119 3.3335 3.75 10.7954 3.75 20.0002C3.75 29.2048 11.2119 36.6668 20.4167 36.6668C29.6213 36.6668 37.0833 29.2048 37.0833 20.0002Z" stroke="#FC8A8C" stroke-width="2.5625" />
                        </svg>
                        <h5>400</h5>
                        <h6>Invalid / Duplicate Events</h6>
                    </div>
                    <div className="custom-tabss-new text-center" style={{ margin: '25px', width: '20%' }}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M25.8327 17.4998C25.8327 14.2782 23.221 11.6665 19.9993 11.6665C16.7777 11.6665 14.166 14.2782 14.166 17.4998C14.166 20.7215 16.7777 23.3332 19.9993 23.3332C23.221 23.3332 25.8327 20.7215 25.8327 17.4998Z" stroke="#EBB569" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M36.6673 7.50016C36.6673 5.19898 34.8018 3.3335 32.5007 3.3335C30.1995 3.3335 28.334 5.19898 28.334 7.50016C28.334 9.80135 30.1995 11.6668 32.5007 11.6668C34.8018 11.6668 36.6673 9.80135 36.6673 7.50016Z" stroke="#EBB569" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M23.334 3.6669C22.257 3.44826 21.1422 3.3335 20.0007 3.3335C10.7959 3.3335 3.33398 10.7954 3.33398 20.0002C3.33398 29.2048 10.7959 36.6668 20.0007 36.6668C29.2053 36.6668 36.6673 29.2048 36.6673 20.0002C36.6673 18.8587 36.5525 17.7438 36.334 16.6668" stroke="#EBB569" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M30 33.3335C30 27.8107 25.5228 23.3335 20 23.3335C14.4771 23.3335 10 27.8107 10 33.3335" stroke="#EBB569" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        <h5>400</h5>
                        <h6>Lead Conversion %</h6>
                    </div>
                </div>


                <div>
                    <StatsComponent2
                        heading={"Event Funnel View"} Data={statsData}
                        centerText={""} showDropOff={true}
                    />
                </div>


                <div className="row">
                    <div className="col-xs-12">
                        <div className="customDash-table" style={{ marginTop: '30px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h5>Event-wise Performance Table</h5>
                                
                            </div>
                            <div className='main-customized-table'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>Event Code</th>
                                            <th>Event Name</th>
                                            <th>Aggregator</th>
                                            <th>Partner</th>
                                            <th>Campaign</th>
                                            <th>Total Count</th>
                                            <th>Unique Users</th>
                                            <th>Lead Counted</th>
                                            <th>Duplicated</th>
                                            <th>Duplicate Count</th>
                                            <th>CRM Mapping Key</th>
                                            <th>Qualifying Event</th>
                                            <th>Status</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            tableData?.length > 0 ? tableData?.map((val, id) => {
                                                return (
                                                    <tr key={id}>

                                                        <td></td>
                                                    </tr>
                                                )
                                            })
                                                : ""}

                                        <tr>
                                            <td>
                                                Lorem Ipsum
                                            </td>
                                            <td>
                                                Loan Approved
                                            </td>
                                            <td>
                                               Aggregator Q
                                            </td>
                                            <td>
                                                Partner A
                                            </td>
                                            <td>
                                                Campaign Alpha
                                            </td>
                                            <td style={{color:'#4FA564'}}>
                                                650
                                            </td>
                                            <td>
                                                500
                                            </td>
                                            <td>
                                                50
                                            </td>
                                            <td>
                                                <div style={{ display:'inline-block',borderRadius: '4px', padding: '8px', background: "#8A38F51A", color: "#8A38F5" }}>
                                                    Yes
                                                </div>
                                            </td>
                                            <td>
                                                100
                                            </td>
                                            
                                             <td>
                                                <div style={{ display:'inline-block',borderRadius: '4px', padding: '8px', background: "#FFF5C7", color: "#A47E06" }}>
                                                    CPR
                                                </div>
                                            </td>
                                             <td>
                                                <div style={{ display:'inline-block',borderRadius: '4px', padding: '8px', background: "#8A38F51A", color: "#8A38F5" }}>
                                                    Yes
                                                </div>
                                            </td>
                                            <td>
                                                <div style={{ display:'inline-block',borderRadius: '4px', padding: '8px', background: "#35A04F2B", color: "#327E45" }}>
                                                    Active
                                                </div>
                                            </td>
                                            <td>

                                            </td>

                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
